import React, { useState, useEffect, useCallback } from 'react';
import axios from '../../api/api';
import { MdOutlineBlock } from 'react-icons/md';
import { FaSearch } from "react-icons/fa";
import { Link } from 'react-router-dom'
import { toast } from 'sonner'
import Loader from '../Loader';

const Customers = () => {

  // user details
  const currentUser = window.localStorage.getItem('token');
  const user = JSON.parse(currentUser).data.user_data;

  const [customer, setCustomer] = useState([]);
  const [searchCustomer, setSearchCustomer] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searched, setSearched] = useState(false);
  const [selectedRequestId, setSelectedRequestId] = useState('');
  const [points, setPoints] = useState('')

  // Fetch all customers
  const getCustomers = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      let query = ""

      if (!searchCustomer) {
        setLoading(false);
        return;
      }

      if (searchCustomer) {
        query += `?msisdn=${searchCustomer}`
      }

      const response = await axios.get(`/customer/${query}`);
      setCustomer(response.data.items);
      setLoading(false);
      setError(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
      if (!error?.response?.status) {
        setError('Network error! Check your connection.');
      } else if (error.response.status === 400 || error.response.status === 404) {
        setError(error.response.data?.detail || 'Invalid request or resource not found');
      } else if (error.response.status === 500) {
        setError(error.response.data?.detail || 'Server error');
      } else {
        setError(error.response.data?.detail || 'Oops! Something went wrong! Try Again');
      }
    } finally {
      setLoading(false);
    }
  }, [searchCustomer]);


  // Handle search button click
  const handleSearch = () => {
    setSearched(true);
    getCustomers();
  };

  // Handle clearing search inputs
  const handleClearSearch = () => {
    setSearchCustomer('');
    setCustomer([]); 
    setSearched(false); 
  };

  // Fetch data only if a search has been performed
  useEffect(() => {
    if (searched) getCustomers();
  }, [getCustomers, searched]);

  // getting customer points
  const openModal = async (id) => {
    setSelectedRequestId(id);
    const dialog = document.getElementById('my_modal_3');
    if (dialog !== null) {
      dialog.showModal();
    }
  
    try {
      const response = await axios.get(`/customer/${id}/details`);
      setPoints(response.data.points);
    } catch (error) {
      console.error("Error fetching customer points:", error);
    }
  };

  // update points
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`/customer/${selectedRequestId}/points`, {
        points
      })
      toast.success("Points updated successfully")
      document.getElementById('my_modal_3').close()
      getCustomers()
    } catch (error) {
      console.log(error)
      toast.error('Failed to update points')
    }
  }


  return (
    <div className='mx-auto p-4'>
      <h3 className="my-2"><b>Customers</b></h3>
      <div className="bg-white rounded-lg p-4 w-full flex-1 min-w-0">
        <div className='flex space-x-2 items-center mb-4'>
          <label htmlFor='search'><span className='hidden'>Search</span>
            <input
              type='text'
              id='search'
              className='px-3 py-1 w-full border bg-[#eef1ff] border-slate-300 placeholder-slate-400 rounded-md focus:outline-none focus:border-[#2b1e3e] focus:ring-[#2b1e3e] focus:ring-1'
              required
              placeholder='Search customer...'
              value={searchCustomer}
              onChange={(e) => setSearchCustomer(e.target.value)}
            />
          </label>
          <button
            onClick={handleSearch}
            className='px-4 py-1 bg-[#2b1e3e] text-white rounded-md'
          >
            Search
          </button>
          <button
            onClick={handleClearSearch}
            className='px-4 py-1 bg-red-500 text-white rounded-md'
          >
            Clear
          </button>
        </div>
        {loading ? (
          <div className='flex items-center justify-center bg-[#eef1ff] h-[70vh]'>
            <Loader />
          </div>
        ) : error ? (
          <div className='bg-[#eef1ff] grid place-items-center h-[70vh]'>
            <div className='grid place-items-center text-red-600 p-4'>
              <h3><MdOutlineBlock /></h3>
              <span>{error}</span>
            </div>
          </div>
        ) : (
          searched ? (
          <div className='overflow-x-auto rounded-lg'>
            {customer.length > 0
              ? (
                <table className='w-full text-left table-auto'>
                  <thead>
                    <tr className='border-b border-slate-500'>
                      <th className='p-2'>Phone Number</th>
                      <th className='p-2'>Commission</th>
                      <th className='p-2 whitespace-nowrap'>Net Value</th>
                      <th className='p-2'>Overdraft</th>
                      <th className='p-2 whitespace-nowrap'>Units Consumed</th>
                      <th className='p-2'>Points</th>
                      <th className='p-2'>Status</th>
                      <th className='p-2 whitespace-nowrap'>User Type</th>
                      <th className='p-2 whitespace-nowrap'>Created At</th>
                      <th className='p-2'>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {customer.map((customers) => (
                      <tr key={customers.id}>
                        <td className='p-2'>{customers.msisdn}</td>
                        <td className='p-2'>KES {customers.commission}</td>
                        <td className='p-2 whitespace-nowrap'>KES {customers.net_value}</td>
                        <td className='p-2 whitespace-nowrap'>KES {customers.overdraft}</td>
                        <td className='p-2'>KES {customers.unit_consumed}</td>
                        <td className='p-2'>{customers.points}</td>
                        <td className='p-2'>{customers.status}</td>
                        <td className='p-2'>
                          {customers.user_type === 1 ? (
                            <span>Customer</span>
                          ) : customers.user_type === 2 ? (
                            <span>Agent</span>
                          ) : (
                            <span>Dealer</span>
                          )}
                        </td>
                        <td className='p-2 whitespace-nowrap'>{new Date(customers.date_created).toLocaleString("en-CA", { hour12: false })}</td>
                        <td className='p-2 flex gap-2'>
                          <Link to={`/customer/${customers.id}`}><span className='border border-[#1F2937] px-5 py-0.5 rounded-full'>View</span></Link>
                          {(user.role === 'SYSTEM_ADMIN' || user.role === 'FINANCE') && (
                            <>
                              <button
                                onClick={() => {openModal(customers.id)}}
                                className='bg-[#134463] text-white px-4 hover:bg-[#2b1e3e] rounded-full'
                              >
                                Update
                              </button>
                              <dialog id="my_modal_3" className="modal">
                                <div className="modal-box">
                                  <form method="dialog">
                                    {/* if there is a button in form, it will close the modal */}
                                    <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
                                  </form>
                                  <form onSubmit={handleSubmit}>
                                    <div className='mt-2'>
                                      <label htmlFor=""><span>Points</span>
                                      <input 
                                        type="number"
                                        placeholder="Points"
                                        className='px-3 py-2 bg-white border border-slate-300 placeholder-slate-400 focus:outline-none focus:border-yellow-500 focus:ring-yellow-500 w-full rounded-md focus:ring-1'
                                        value={points}
                                        onChange={(e) => {setPoints(e.target.value)}}
                                      />
                                      </label>
                                    </div>
                                    <div className='mt-3'>
                                      <button className='bg-[#134463] text-white px-4 py-0.5 hover:bg-[#134463da] rounded-full'>Update</button>
                                    </div>
                                  </form>
                                </div>
                              </dialog>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className='bg-[#eef1ff] text-[#134463] grid place-items-center h-[70vh]'>
                  <div className='grid place-items-center p-4'>
                    <h3><MdOutlineBlock /></h3>
                    <h4>No Data</h4>
                  </div>
                </div>
              )}
          </div>
          ) : (
            <div className='grid place-items-center h-[70vh]'>
              <div className='text-[#134463] p-4'>
                <h3 className='flex items-center justify-center'><FaSearch /></h3>
                <h4>Search Customer Details</h4>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Customers;